export function DoroPartyWordmark({ compact = false, showKorean = false, className = '' }) {
  const classes = ['doroparty-wordmark', compact ? 'compact' : '', showKorean ? 'with-korean' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} aria-label="DoroParty">
      <span className="doroparty-wordmark-main" aria-hidden="true">
        <span className="doroparty-wordmark-doro">Doro</span>
        <span className="doroparty-wordmark-party">Party</span>
      </span>
      {showKorean ? <small aria-hidden="true">도로파티</small> : null}
    </span>
  );
}
